import $ from 'jquery';

const ACTIVE = 'active';
const menu = () => {
  const nav = $('.c-main-nav');

  if (nav && nav.length) {
    const toggle = nav.find('.c-main-nav__toggle');
    const navMenu = nav.find('.c-main-nav__list');
    toggle.click(() => {
      navMenu.toggleClass(ACTIVE);
    });

    const searchToggle = nav.find('.c-main-nav__search .c-main-nav__link');
    const searchMain = nav.find('#search');
    if (searchToggle && searchToggle) {
      searchToggle.click(ev => {
        ev.preventDefault();
        searchMain.toggleClass(ACTIVE);
      });
    }

    const modelSearchToggle = nav.find('[href="#model-search"]');
    const modelSearchMain = nav.find('#model-search');
    if (modelSearchToggle && modelSearchToggle) {
      modelSearchToggle.click(ev => {
        ev.preventDefault();
        modelSearchMain.toggleClass(ACTIVE);
      });
    }

    const closeSearch = nav.find('.c-main-nav__search-close');
    if (closeSearch && closeSearch.length) {
      closeSearch.click(ev => {
        const $self = $(ev.target);
        $self.parent().removeClass(ACTIVE);
      });
    }

    const $win = $(window);
    const navSearches = $('.c-main-nav__search-field');
    const navMenuList = navMenu.find('.c-main-nav__list-list');
    if (navSearches.length) {
      navSearches.on('focus', () => {
        if ($win.width() < 960) {
          navMenu.addClass('input-focused');
          setTimeout(() => {
            navMenuList.scrollTop(999);
          });
        }
      });
      navSearches.on('blur', () => {
        if ($win.width() < 960) {
          navMenu.removeClass('input-focused');
        }
      });
    }
  }
};
export default menu;



// WEBPACK FOOTER //
// ./src/scripts/modules/menu.js